/**
 * @fileoverview GET handler for the "/companies/:company_id/developers/permission_structures" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdDevelopersPermissionStructures } from "./constants";
import type { CompaniesCompanyIdDevelopersPermissionStructuresResultJson } from "./types";

export const getCompaniesCompanyIdDevelopersPermissionStructures = reactQueryFetcherAdapter(
  companiesCompanyIdDevelopersPermissionStructures,
  (signal: AbortSignal, companyId: string): Promise<CompaniesCompanyIdDevelopersPermissionStructuresResultJson> => {
    return fetch(`/companies/${companyId}/developers/permission_structures`, "GET", {}, { signal });
  }
);
